<template>
  <div class="min-h-screen bg-gray-50 pb-28" dir="rtl">
    <!-- Header Card -->
    <div class="px-4 pt-4 pb-3">
      <div class="max-w-2xl mx-auto">
        <div class="bg-gradient-to-r from-blue-600 to-blue-700 rounded-2xl p-6 text-white">
          <div class="flex items-center justify-between mb-2">
            <h1 class="w-full text-2xl font-bold">کالاها</h1>
          </div>
          <p class="text-blue-100 text-sm">کالاهای مورد نیاز را اضافه کنید</p>
        </div>
      </div>
    </div>

    <!-- Add new product button (top) -->
    <div v-if="$route.params.rec_id==0" class="px-4 pt-4 pb-3">
      <div class="max-w-2xl mx-auto bg-white rounded-lg border border-gray-200 p-6 cursor-pointer hover:shadow-md transition-all duration-200 active:scale-95" @click="dialog_model=true,model_txt=''">
        <div class="flex items-center justify-between group">
          <div class="flex items-center gap-3">
            <img src="/img/svg/add-circle.svg" alt="Add" class="w-6 h-6">
            <span class="text-gray-900 font-medium">{{ $t('addNewProduct') }}</span>
          </div>
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" class="w-5 h-5 text-gray-400 group-hover:text-gray-600 transition-colors">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
          </svg>
        </div>
      </div>
    </div>

    <!-- List -->
    <div class="px-4 pt-4">
      <div class="max-w-2xl mx-auto space-y-3">
        <div v-for="(item,index) in list" :key="item.Id" class="bg-white rounded-xl border border-gray-200 p-5 hover:shadow-md transition-all duration-200">
          <div class="flex items-start items-center gap-4">
            <!-- Product Info -->
            <div class="w-full">
              <h3 class="text-base font-bold text-gray-900 mb-3">{{ item.ProductName }}</h3>
              
              <!-- Quantity -->
              <div class="flex items-center gap-2 mb-3">
                <svg class="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                </svg>
                <span class="text-sm text-gray-700">{{ item.Qty }} {{ $t('numbers') }}</span>
              </div>

              <!-- Prices -->
              <div class="grid grid-cols-2 gap-3 mt-4">
                <!-- Purchase Price -->
                <div class="bg-green-50 rounded-lg px-3 py-2 border border-green-200">
                  <div class="text-xs text-green-700 font-medium mb-1">قیمت خرید</div>
                  <div class="text-sm font-bold text-green-800">{{ formatPrice(item.PurchaseAmount) }} تومان</div>
                </div>
                
                <!-- Sale Price -->
                <div class="bg-blue-50 rounded-lg px-3 py-2 border border-blue-200">
                  <div class="text-xs text-blue-700 font-medium mb-1">قیمت فروش</div>
                  <div class="text-sm font-bold text-blue-800">{{ formatPrice(item.SaleAmount) }} تومان</div>
                </div>
              </div>

              <!-- Status (if exists) -->
              <div v-if="item.StatusName" class="mt-3">
                <span class="text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded">{{ item.StatusName }}</span>
              </div>
            </div>
            
            <!-- Action Buttons -->
            <div class="flex flex-col gap-2 flex-shrink-0">
              <!-- Edit/Attach Button (Image Icon) -->
              <button 
                class="w-10 h-10 inline-flex items-center justify-center rounded-lg bg-blue-50 hover:bg-blue-100 text-blue-600 transition-colors" 
                @click.stop="attach_dialog(item)"
                title="پیوست‌ها"
              >
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
              </button>
              
              <!-- Delete Button (if editable) -->
              <button 
                v-if="$route.params.rec_id==0"
                class="w-10 h-10 inline-flex items-center justify-center rounded-lg bg-red-50 hover:bg-red-100 text-red-600 transition-colors" 
                @click.stop="delete_dialog(index)"
                title="حذف"
              >
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="w-full text-center mt-3">
      <label v-if="list.length && $route.params.rec_id==0" class="text-white">{{ $t('click_for_add_product_order') }}</label>
    </div>
    <div class=" max-w-2xl mx-auto fixed bottom-24 left-0 right-0">
      <button v-if="list.length && $route.params.rec_id==0" class="py-4 px-6 w-full bg-blue-600 text-white font-bold rounded-lg" @click="pre_upload_files()">
        {{ $t('add_product_order') }}
      </button>
    </div>

    <!-- Modal: Add product -->
    <div v-if="dialog_model" class="fixed inset-0 z-999 flex items-start sm:items-center justify-center bg-black bg-opacity-40">
      <div class="w-full h-full sm:h-auto sm:max-w-lg bg-white sm:rounded-2xl sm:shadow-xl overflow-hidden">
        <div class="px-4 pt-4 pb-2 border-b border-gray-100 text-gray-900 font-bold">{{ $t('addProduct') }}</div>
        <div class="p-4 space-y-4">
          <div>
            <treeselect
              :multiple="false"
              :load-options="load_models"
              :normalizer="normalizer_models"
              :format-option-label="formatOptionLabel"
              :async="true"
              :always-open="always_open"
              :append-to-body="false"
              :placeholder="$t('searchProduct')"
              v-model="auto_complete_model"
              
            />
            <div class="text-xs text-gray-500 mt-1">{{ model_txt }}</div>
          </div>

          <div class="grid grid-cols-12 gap-3">
            <div class="col-span-6 sm:col-span-4">
              <input :placeholder="$t('count')" v-model="product_count" style="border: 1px solid #d1d5db !important;" class="w-full h-10 rounded-lg border border-gray-300 bg-white px-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
            </div>
            <div class="col-span-12">
              <input :placeholder="$t('description')" v-model="product_summary" style="border: 1px solid #d1d5db !important;" class="w-full h-10 rounded-lg border border-gray-300 bg-white px-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
            </div>
          </div>

          <div class="grid grid-cols-12 gap-3">
            <div class="col-span-12 sm:col-span-6">
              <label class="block text-xs text-gray-600 mb-1">قیمت خرید</label>
              <input
                v-model="product_buy_price"
                type="tel"
                inputmode="numeric"
                pattern="[0-9]*"
                placeholder="مثلاً 1,000,000"
                style="border: 1px solid #d1d5db !important;"
                class="w-full h-10 rounded-lg border border-gray-300 bg-white px-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div class="col-span-12 sm:col-span-6">
              <label class="block text-xs text-gray-600 mb-1">قیمت فروش</label>
              <input
                v-model="product_sell_price"
                type="tel"
                inputmode="numeric"
                pattern="[0-9]*"
                placeholder="مثلاً 1,000,000"
                style="border: 1px solid #d1d5db !important;"
                class="w-full h-10 rounded-lg border border-gray-300 bg-white px-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>
        </div>
        <div class="px-4 py-3 border-t border-gray-100 flex items-center justify-end gap-2">
          <button @click="dialog_model = false" class="h-9 px-4 rounded-lg bg-gray-100 text-gray-800 text-sm">{{ $t('cancel') }}</button>
          <button v-if="auto_complete_model!=null" @click="goToDetail()" class="h-9 px-4 rounded-lg bg-blue-600 text-white text-sm font-bold">{{ $t('ok') }}</button>
          <button v-if="auto_complete_model==null" @click="goToNewProduct()" class="h-9 px-4 rounded-lg bg-blue-600 text-white text-sm font-bold">افزودن کالای جدید</button>
        </div>
      </div>
    </div>

    <!-- Modal: Delete confirm -->
    <div v-if="delete_dialog_modal" class="fixed inset-0 z-999 flex items-center justify-center bg-black bg-opacity-40">
      <div class="w-11/12 max-w-sm bg-white rounded-2xl shadow-xl overflow-hidden">
        <div class="px-4 pt-4 pb-2 border-b border-gray-100 text-gray-900 font-bold">{{ $t('deleteProduct') }}</div>
        <div class="p-4 text-sm text-gray-700">{{ $t('sureToDeleteProduct') }}</div>
        <div class="px-4 py-3 border-t border-gray-100 flex items-center justify-end gap-2">
          <button @click="delete_dialog_modal = false" class="h-9 px-4 rounded-lg bg-gray-100 text-gray-800 text-sm">{{ $t('no') }}</button>
          <button @click="delete_dialog_modal = false,list.splice(status_form,1)" class="h-9 px-4 rounded-lg bg-red-600 text-white text-sm font-bold">{{ $t('yes') }}</button>
        </div>
      </div>
    </div>

    <!-- Modal: Attachments -->
    <div v-if="show_attach_dialog" class="fixed inset-0 z-999">
      <div class="absolute inset-0 bg-black bg-opacity-60" @click="show_attach_dialog = false"></div>
      <div class="relative z-10 flex h-full w-full items-center justify-center p-4">
        <div class="w-full max-w-2xl bg-white border border-gray-200 rounded-2xl shadow-xl overflow-hidden flex flex-col max-h-90vh">
          <!-- Header -->
          <div class="flex items-center justify-between px-6 py-4 border-b border-gray-200 bg-gradient-to-r from-blue-600 to-blue-700 flex-shrink-0">
            <h2 class="w-full text-center text-lg font-bold text-white">{{ $t('attachments') }}</h2>
            <button 
              @click="show_attach_dialog = false"
              class="w-8 h-8 rounded-lg bg-white bg-opacity-20 hover:bg-white hover:bg-opacity-30 flex items-center justify-center transition-colors flex-shrink-0"
            >
              <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          
          <!-- Body -->
          <div class="px-6 py-6 overflow-y-auto flex-1">
            <div class="space-y-4">
              <button class="flex gap-2 rounded-lg p-4 items-center justify-between w-full" @click="select_file()" style="border: 1px solid #d1d5db !important;"> 
                <div class="h-10 w-10 rounded-lg  text-white flex items-center gap-2">
                  <img src="/img/svg/add-circle.svg" alt="Add" class="w-7 h-7">
                  <div class="text-sm text-black font-medium">{{ $t('add_file') }}</div>
                </div>
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" class="w-5 h-5 text-gray-400 group-hover:text-gray-600 transition-colors"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path></svg>
              </button>

              <input id="fileUpload" accept=".jpg,.jpeg,.png,.JPG,.JPEG,.gif" type="file" hidden @change="input_file_changed">

              <div v-if="selected_item_attach.files && selected_item_attach.files.length > 0" class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 mt-6">
                <div v-for="(item, i) in selected_item_attach.files" :key="i" class="relative group">
                  <button class="absolute -top-2 -right-2 w-7 h-7 rounded-full bg-red-600 hover:bg-red-700 text-white flex items-center justify-center transition-colors shadow-lg z-10" @click="delete_file(i)">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                  <div class="text-xs text-gray-600 mb-2 truncate font-medium">{{ item.title}}</div>
                  <div class="aspect-square rounded-lg overflow-hidden bg-gray-100 border border-gray-200">
                    <img :src="item.file" class="w-full h-full object-cover" />
                  </div>
                </div>
              </div>
              <div v-else class="text-center py-8 text-gray-400 text-sm">
                هیچ فایلی اضافه نشده است
              </div>
            </div>
          </div>
          
          <!-- Footer -->
          <div class="px-6 py-4 border-t border-gray-200 flex items-center justify-end gap-3 flex-shrink-0">
            <button @click="show_attach_dialog = false" class="h-10 px-6 rounded-lg bg-gray-100 hover:bg-gray-200 text-gray-800 text-sm font-medium transition-colors">
              {{ $t('close') || 'بستن' }}
            </button>
            <button @click="show_attach_dialog = false" class="h-10 px-6 rounded-lg bg-blue-600 hover:bg-blue-700 text-white text-sm font-bold transition-colors shadow-md">
              {{ $t('ok') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
import Treeselect, {ASYNC_SEARCH} from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

import axios from 'axios'
import Vue from 'vue'

import {bus} from '../../main'

const simulateAsyncOperation = fn => {
  setTimeout(fn, 200)
}
export default {
  props: [
    'passing_data'
  ],
  data() {
    return {
      auto_complete_model: null,
      search_entries: [],
      model_txt: '',
      is_pre: '',
      always_open: true,
      delete_dialog_modal: false,
      status_form: 0,
      dialog_model: false,
      product_count: '',
      product_summary: '',
      product_sell_price: '',
      product_buy_price: '',

      product_items: [],
      upload_images: [],
      branch_id: 0,
      list: [],
      errors: [],
      selected_post: 0,
      selected_branch: 0,
      // request_items: [],
      // last_request_items: [],
      show_loading: false,
      no_info: true,
      page: 0,
      selected_item_attach: {},
      show_attach_dialog: false,
      treeselectObserver: null,

      normalizer_models(node) {
        return {
          id: node.ProductId,
          label: node.ProductName,
          isPreProduct: node.IsPreProduct,
        }
      },
      formatOptionLabel({ option }) {
        // Check if this is a pre-product (IsPreProduct === 1)
        // Return the label as is, CSS will handle the styling
        return option.label
      },
      first: true,
    }
  },
  computed: {},
  components: {Treeselect},
  watch: {
    auto_complete_model() {
      if (this.auto_complete_model == null) {
        this.always_open = true;
      } else {
        this.always_open = false;

      }

      for (var i = 0; i < this.search_entries.length; i++) {
        if (this.search_entries[i].ProductId == this.auto_complete_model) {
          this.model_txt = this.search_entries[i].ProductName
          this.is_pre = this.search_entries[i].IsPreProduct
        }
      }
    },
    product_buy_price() {
      const formatted = this.formatAmountInput(this.product_buy_price)
      if (this.product_buy_price !== formatted) {
        this.product_buy_price = formatted
      }
    },
    product_sell_price() {
      const formatted = this.formatAmountInput(this.product_sell_price)
      if (this.product_sell_price !== formatted) {
        this.product_sell_price = formatted
      }
    },
  },
  mounted() {
    if (this.$route.params.rec_id != 0) {
      this.get_factors()
    }
    this.get_branch_permission()

    this.selected_post = parseInt(localStorage.getItem('selected_post'))
  },
  beforeDestroy() {
    // Clean up observer
    if (this.treeselectObserver) {
      this.treeselectObserver.disconnect()
      this.treeselectObserver = null
    }
  },

  methods: {
    select_file() {
      document.getElementById('fileUpload').click()
    },
    delete_file(index) {
      this.selected_item_attach.files.splice(index, 1)
    },
    input_file_changed() {
      var self = this

      var reader = new FileReader()
      var f = document.getElementById('fileUpload').files

      reader.onloadend = function () {
        // console.log(reader.result);
        if (!reader.result.startsWith('data:image/webp')) {
          self.resizeBase64Img(reader.result, 700, 700).then(function (newImg) {
            // $("body").append(newImg[0]);
            // console.log("resized",newImg[0].src)
            var obj = {file: newImg[0].src, preview: reader.result, upload: 0}
            self.selected_item_attach.files.push(obj)
          })
          // console.log(obj)
        } else {
          bus.$emit('show_toast', [1500, self.$t('fileIsNotGranted')])
        }
      }
      reader.readAsDataURL(f[0])
    },
    resizeBase64Img(base64, minimum) {
      var canvas = document.createElement('canvas')

      var deferred = $.Deferred()
      $('<img/>').attr('src', base64).load(function () {
        var last_width = this.width
        var last_height = this.height

        if (last_width > last_height) {
          last_width = (last_width * minimum) / last_height
          last_height = minimum
        } else {
          last_height = (last_height * minimum) / last_width
          last_width = minimum
        }
        canvas.width = last_width
        canvas.height = last_height
        var context = canvas.getContext('2d')

        console.log(this.width, this.height)
        context.scale(last_width / this.width, last_height / this.height)
        context.drawImage(this, 0, 0)

        deferred.resolve($('<img/>').attr('src', canvas.toDataURL()))
      })
      return deferred.promise()
    },

    attach_dialog(item) {
      this.show_attach_dialog = true;
      this.selected_item_attach = item;
    },
    delete_dialog(index) {
      if (this.$route.params.rec_id == 0) {
        this.delete_dialog_modal = true
        this.status_form = index
      }
    },
    load_models({action, searchQuery, callback}) {
      this.model_txt = searchQuery
      this.auto_complete_model = null
      var self = this
      if (action === ASYNC_SEARCH) {
        simulateAsyncOperation(() => {
          let options

          var passing_data = JSON.parse(localStorage.getItem('request_data'))

          const send_data = {
            MainProductId: 0,
            TxtSearch: searchQuery,
          }
          this.axios.post('/GetProductLowInfosByKeword_GoodsReq', send_data, {
            show_pros: false // Disable full-screen loading for search
          })
            .then(response => {
              self.search_entries = response.data.products
              options = response.data.products
              callback(null, options)
              
              // After options are loaded, add data attributes for styling
              self.$nextTick(() => {
                self.stylePreProductOptions()
                // Also use MutationObserver to catch dynamic updates
                self.observeTreeselectOptions()
              })
              // this.$router.push({ path: "/post-login", params: {} });
            }).catch(e => {
            this.errors.push(e)
          })

          //
          // axios.post('/api/admin/product_search-tags', {
          //   search: searchQuery,
          //
          // }).then(function (response) {
          //   options = response.data;
          //   callback(null, options);
          //   // localStorage.setItem("api_token", response.data.access_token);
          //   // self.$router.push({ path: 'notes' });
          // })
          //   .catch(function (error) {
          //     self.message = 'Incorrect E-mail or password';
          //     self.showMessage = true;
          //     console.log(error);
          //   });

          //  const options = this.get_keywords(searchQuery);
          // const options = [1, 2, 3, 4, 5].map(i => ({
          //     id: `${searchQuery}-${i}`,
          //     name: `${searchQuery}-${i}`,
          // }))
        })
      }
    },

    goToDetail() {
      // bus.$emit('show_toast', [2000, this.product_count])

      this.product_count = this.persian_to_english(this.product_count);

      if (this.auto_complete_model != null && this.product_count != 0 && this.product_count != '' &&
        this.parseAmountInput(this.product_buy_price) !== '' && this.parseAmountInput(this.product_sell_price) !== '') {

        this.list.push({
          ProductId: this.auto_complete_model,
          Qty: this.product_count,
          IsPreProduct: this.is_pre,
          ProductName: this.model_txt,
          ProductDesc: this.product_summary,
          SaleAmount: this.parseAmountInput(this.product_sell_price),
          PurchaseAmount: this.parseAmountInput(this.product_buy_price),
          files: [],
          Images: []
        })
        this.dialog_model = false
        this.auto_complete_model = null
        this.product_count = ''
        this.product_summary = ''
        this.product_buy_price = ''
        this.product_sell_price = ''
      }
    },
    goToNewProduct(){
      this.$router.push({path:'/product-request/add-pre-product'})
    },
    get_factors() {
      // this.request_items = [];
      var self = this
      var user_id = JSON.parse(localStorage.getItem('profile')).UserId
      const send_data = {
        UserId: user_id,
        MasterId: this.$route.params.rec_id,
      }

      console.log('pre request called')
      // this.axios.post('/Register' , send_data,{
      this.axios.post('/GetGoodsProductsByMasterId', send_data, {})
        .then(response => {
          self.last_request_items = []
          if (response.data.error == 0) {
            self.list = response.data.items
          }
        }).catch(e => {
        this.errors.push(e)
      })
    },
    get_branch_permission() {
      var self = this
      var user_id = JSON.parse(localStorage.getItem('profile')).UserId
      var party_id = localStorage.getItem('party_id')

      const send_data = {
        UserId: user_id,
        Role: 'BranchDefinition',
        PartyId: party_id,
      }
      // this.axios.post('/Register' , send_data,{
      this.axios.post('/ZkGetUserPermission', send_data, {})
        .then(response => {
          if (response.data.error == 0) {
            this.branch_id = response.data.UserBranchId
          }
        }).catch(e => {
        this.errors.push(e)
      })
    },
    pre_upload_files() {
      this.upload_images = [];
      var first_index_file = -1;
      for (var x = 0; x < this.list.length; x++) {
        if (this.list[x].files.length > 0) {
          if (first_index_file == -1) {
            first_index_file = x;
          }
        }
      }

      if (first_index_file != -1) {
        this.upload_image(first_index_file, 0);
      } else {
        this.add_factor();
      }

    },
    upload_image(item_index, index) {
      console.log("upload file ", item_index, index);
      var self = this
      var user_id = JSON.parse(localStorage.getItem('profile')).UserId
      var form_data = new FormData()
      form_data.append('UserId', user_id)
      form_data.append('Format', 'png')
      form_data.append('ReqType', 9)
      form_data.append('DocType', 1)
      var my_file = this.list[item_index].files[index].file

      var file = this.dataURLtoFile(my_file, 'attach.png')
      form_data.append('Picture', file)

      this.axios.post('UploadFile', form_data, {})
        .then(response => {
          // self.send_signature(response.data.ArchiveId,response.data.ImageName);
          if (response.data.error == 0) {
            self.list[item_index].files[index].upload = 1
            self.list[item_index].files[index].ArchiveId = response.data.ArchiveId;
            self.list[item_index].files[index].ImageName = response.data.ImageName;
            self.list[item_index].Images.push(response.data.ImageName);
            self.upload_images.push({ImageName: response.data.ImageName, ProductId: self.list[item_index].ProductId});

            if (index < self.list[item_index].files.length - 1) {
              self.upload_image(item_index, index + 1)
            } else {
              if (this.list.length - 1 > item_index) {
                var first_index_file = -1;
                for (var x = item_index + 1; x < this.list.length; x++) {
                  if (this.list[x].files.length > 0) {
                    if (first_index_file == -1) {
                      first_index_file = x;
                    }
                  }
                }
                if (first_index_file != -1) {
                  self.upload_image(first_index_file, 0)

                } else {
                  this.add_factor()

                }
              } else {
                this.add_factor()

              }
            }

          } else {
            self.files[index].upload = 2
            bus.$emit('show_toast', [1500, response.data.msg])
          }
        }).catch(e => {
        this.errors.push(e)
      })
    },

    add_factor() {
      // this.request_items = [];
      var self = this
      var user_id = JSON.parse(localStorage.getItem('profile')).UserId
      var product_request = JSON.parse(localStorage.getItem('request_product'))
      var request_id = 0;
      var Payfor = 0;
      if (product_request.request) {
        request_id = product_request.request;
      }
      if (product_request.user) {
        Payfor = product_request.user
      }
      for (var z = 0; z < self.list.length; z++) {
        self.list[z].Images = JSON.stringify(self.upload_images);
      }

      const send_data = {
        SourceBranchId: this.branch_id,
        Summary: product_request.summary,
        DestBranchId: product_request.branch,
        UserId: user_id,
        Payfor: Payfor,
        CategoryId: product_request.category,
        CostCenterId: request_id,
        Products: this.list,
      }

      console.log('pre request called')
      // this.axios.post('/Register' , send_data,{
      this.axios.post('/AddGoodsReq', send_data, {})
        .then(response => {
          self.last_request_items = []
          if (response.data.error == 0) {
            bus.$emit('show_toast', [1500, response.data.msg])
            self.$router.go(-1)
          } else {
            bus.$emit('show_toast', [1500, response.data.msg])
          }
        }).catch(e => {
        this.errors.push(e)
      })
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }

      return new File([u8arr], filename, {type: mime})
    },
    formatPrice(price) {
      if (!price) return '0'
      // Convert to string and add thousand separators
      var priceStr = String(price)
      return priceStr.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    stylePreProductOptions() {
      // Find all treeselect options and add data attribute for pre-products
      const options = document.querySelectorAll('.vue-treeselect__option')
      options.forEach((optionEl) => {
        const label = optionEl.querySelector('.vue-treeselect__label')
        if (label) {
          const labelText = label.textContent.trim()
          // Find matching product in search_entries by ProductName
          const matchingProduct = this.search_entries.find(entry => entry.ProductName === labelText)
          if (matchingProduct && (matchingProduct.IsPreProduct === 1 || matchingProduct.IsPreProduct === '1')) {
            optionEl.setAttribute('data-is-pre-product', '1')
            label.style.color = '#ef4444'
            label.style.fontWeight = '500'
          }
        }
      })
    },
    observeTreeselectOptions() {
      // Use MutationObserver to watch for new options being added
      const menu = document.querySelector('.vue-treeselect__menu')
      if (menu && !this.treeselectObserver) {
        this.treeselectObserver = new MutationObserver(() => {
          this.stylePreProductOptions()
        })
        this.treeselectObserver.observe(menu, {
          childList: true,
          subtree: true
        })
      }
    },

  }
}
</script>
<style>
.v-application .headline {
  font-size: 1rem !important;
  font-weight: 400;
  line-height: 2rem;
  letter-spacing: normal !important;
  font-family: "IRANSans" !important;
}

/* Style for pre-product items in treeselect */
.vue-treeselect__option.is-pre-product .vue-treeselect__label,
.vue-treeselect__option[data-is-pre-product="1"] .vue-treeselect__label,
.vue-treeselect__option[data-is-pre-product="true"] .vue-treeselect__label {
  color: #ef4444 !important;
  font-weight: 500 !important;
}

/* Alternative: Target by checking if option has isPreProduct property */
.vue-treeselect__menu .vue-treeselect__option {
  position: relative;
}

/* Use JavaScript to add data attribute - we'll do this via a method */
</style>